

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  color?: string;
  className?: string;
}

export const LoadingSpinner = ({
  size = 'medium',
  color,
  className = '',
}: LoadingSpinnerProps) => {
  const sizeMap = {
    small: 16,
    medium: 24,
    large: 40,
  };

  const pixelSize = sizeMap[size];

  return (
    <div
      className={`loading-spinner ${className}`}
      style={{
        width: pixelSize,
        height: pixelSize,
        borderColor: color ?? undefined,
      }}
      role="status"
      aria-label="Loading"
    >
      <span className="sr-only">Loading...</span>
    </div>
  );
};

export default LoadingSpinner;
